import { testingSetTestedTexture } from '../../../store/testing/actions';
import Back from '../Back';
import Content from '../Content';
import styles from './Texture.module.scss';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

const Texture = ({ payload }) => {
  const textures = useSelector((state) => [
    { key: undefined, name: 'default' },
    ...state.testing.createdTextures.map((t) => ({
      key: t,
      name: t,
    })),
  ]);
  const testedTexture = useSelector((state) => state.testing.testedTexture);

  const dispatch = useDispatch();

  return (
    <>
      <Back title="Texture Name" index={payload.menuIndex} />

      <Content>
        <ul className={styles.list}>
          {textures.map((texture, index) => {
            return (
              <li
                key={index}
                onClick={() => {
                  dispatch(testingSetTestedTexture(texture.key));
                }}
              >
                <div className={cn(styles.checkbox, texture.key === testedTexture && styles.checked)}></div>
                <div className={styles.name}>{texture.name}</div>
              </li>
            );
          })}
        </ul>
      </Content>
    </>
  );
};

export default Texture;
